export function isHidden(element) {
  return window.getComputedStyle(element).display === 'none' || element.offsetParent === null;
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/utils/dom/style.js
// module id = 328
// module chunks = 1